<!-- 维护控销 -->
<template>
   <div>
      <div>
         <el-switch v-model="allAndself" @change="changeSwitch()" active-text="整单规则" inactive-text="明细规则" :active-value="true" :inactive-value="false">
         </el-switch>
      </div>
      <div class="pin-top">
         <div class="conpin-left">
            <el-card class="box-card">
               <div slot="header" class="clearfix">
                  <span>明细数据</span>
                  <el-button style="float: right;" type="danger" size="mini" v-if="!allAndself" @click="delcurrent()">删除</el-button>
               </div>
               <div class="text item" v-if="allAndself">
                  <el-table ref="multipleTable" size="mini" class="baseTable" stripe :data="mainFormPin.pisOrderDetail" border tooltip-effect="dark" style="width: 100%;height:500px"
                     @selection-change="handleSelectionChange">
                     <el-table-column label="选择操作" type="selection" :show-overflow-tooltip="true" :selectable="selectHandle">
                     </el-table-column>
                     <el-table-column label="通用名称" prop="bgmName" :show-overflow-tooltip="true" :selectable="selectHandle">
                     </el-table-column>
                     <el-table-column prop="spec" label="规格" :show-overflow-tooltip="true" :selectable="selectHandle">
                     </el-table-column>
                     <el-table-column prop="manufacturer" label="生产厂家" :show-overflow-tooltip="true" :selectable="selectHandle">
                     </el-table-column>
                  </el-table>
               </div>
               <div class="text item" v-else>
                  <el-table ref="multipleTable" size="mini" class="baseTable" stripe :data="mainFormPin.pisOrderDetail" border tooltip-effect="dark" style="width: 100%;height:500px">
                     <el-table-column label="选择操作" :show-overflow-tooltip="true" :key="1">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDetailsIndex1" :label="scope.$index" border size="mini" @input="changeinput(scope.row)">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column label="通用名称" prop="bgmName" :show-overflow-tooltip="true">
                     </el-table-column>
                     <el-table-column prop="spec" label="规格" :show-overflow-tooltip="true">
                     </el-table-column>
                     <el-table-column prop="manufacturer" label="生产厂家" :show-overflow-tooltip="true">
                     </el-table-column>
                  </el-table>
               </div>
            </el-card>
         </div>
         <div class="conpin-right">
            <el-card class="box-card">
               <div slot="header" class="clearfix">
                  <span>规则维护</span>
               </div>
               <div class="text item">
                  <el-form ref="form" :model="formData" label-width="80px">
                     <el-form-item label="规则维护">
                        <el-radio-group v-model="formData.resource" @input="changeGZ()">
                           <el-radio label="0">单位</el-radio>
                           <el-radio label="1">单位类型</el-radio>
                           <el-radio label="2">地区</el-radio>
                        </el-radio-group>
                     </el-form-item>
                     <el-form-item label="控销数量" v-if="!allAndself">
                        <el-input v-model.trim="formData.quantity" size="mini" :maxlength="$store.state.inputLength"></el-input>
                     </el-form-item>
                  </el-form>
                  <div style="margin-bottom: 0.5rem;">
                     <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                        新增</el-button>
                     <el-button type="danger" size="mini" @click="deleteDetails()">删除
                     </el-button>
                     <!-- <el-button type="primary" size="mini" @click="preservation()" v-if="!allAndself">保存
                     </el-button> -->
                  </div>
                  <el-table size="mini" class="baseTable" ref="mxTableRef" :data="sendDataInfo.pisOrderDetail" border style="width: 100%">
                     <el-table-column label="选择操作" width="80">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column prop="cpdtName" label="内容" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable v-model="sendDataInfo.pisOrderDetail[scope.$index].cpdtValue" @keyup.enter.native="openSearch('',scope.$index,'')">
                              <el-button @click="openSearch('',scope.$index,'')" slot="append" icon="el-icon-search">
                              </el-button>
                           </el-input>
                        </template>
                     </el-table-column>
                  </el-table>
               </div>
            </el-card>
            <div>
               <el-button type="primary" @click="setDetail()" size="mini">确定保存</el-button>
            </div>
         </div>
         <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
         </el-dialog>
      </div>
   </div>

</template>

<script>
export default {
   name: "maintenanceControlPinAciton",
   props: ["mainFormPin", "actionType"],
   //import引入的组件需要注入到对象中才能使用
   components: {},
   data() {
      return {
         search: "",
         allAndself: true,
         tabdata: [],
         formData: {
            resource: "0",
            quantity: 0,
         },
         isLoaded: false,
         DialogVisible: false,
         sendDataInfo: {
            pisOrderDetail: [],
         },
         multipleSelection: [],
         detaislDataInfo: {
            bgmId: "",
            bgmName: "",
            inRate: 0,
            money: 0,
            psodPacknum: 0,
            price: 0,
            psodPsdvolume: 0,
            psodPslowerlimit: 0,
            psmoney: 0,
            psodPsnvolume: 0,
            psprice: 0,
            // 进项税率
            inRate: 0,
            psodPsupperlimit: 0,
            psodReserves1: "",
            psodReserves2: "",
            psodReserves3: "",
            psodReserves4: "",
            psodReserves5: "",
            psodReserves6: "",
            psomId: "",
            pspdId: "",
            stId: "",
            depId: "",
            lastPuprice: "", //	最后一次采购价
            spec: "",
            manufacturer: "",
            scopeName: "",
            placeorigin: "",
            mne: "",
            bgiAppnumber: "",
            pieceNum: "", //件数
         },
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         seId: "",
         seIndex: 0, //选中索引
         seType: "",
         sField: "", // 赋值字段
         fField: "", //焦点字段
         nosField: "", // 不可赋值字段
         parentSearchData: {
            smId: "",
            orderType: 1, //	订单类型0.药品1.器械
            dtId: "",
         },
         selectedDetailsIndex: 0,
         selectedDetailsIndex1: 0,
         params: [],
         params1: [],
         controlGoodTempAdds: [],
         controlGoodTempAdds11: [],
         setcpd: {
            cmId: 0,
            cpdtValue: "",
         },
         setcpd1: {
            cmId: 0,
            cpdtValue: "",
         },
         setPin: {
            controlRule: [],
         },
         setPin1: {},
         setPin2: {},
         setPin3: {},
         psodPacknum: 0,
         minpsodPacknum: 99999,
         isshow: null,
         mingList: [],
         mingListDan: {},
         tabshow:0,
      };
   },
   watch: {
      formData: {
         handler: function (newvalue, oldvalue) {
            // if(newvalue.quantity > )
            if (!this.allAndself) {
               this.params1[this.selectedDetailsIndex1].controlType =
                  newvalue.resource;
               this.params1[this.selectedDetailsIndex1].quantity =
                  newvalue.quantity;
               sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
               console.log(this.params1, "params1");
            }
         },
         deep: true,
      },
      "sendDataInfo.pisOrderDetail": {
         handler: function (newvalue, oldvalue) {
            if (!this.allAndself) {
               console.log(this.mingListDan, this.mingListDan.bgmId, "sss");
               this.params1[this.selectedDetailsIndex1]["controlRule"] =
                  newvalue;
               sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
               console.log(this.params1, "params1");
            }
         },
      },

      allAndself: {
         handler: function (newvalue, oldvalue) {
            this.multipleSelection = [];
            this.$refs.multipleTable &&
               this.$refs.multipleTable.clearSelection();
            if (newvalue) {
               //开关打开时 全选
               this.mainFormPin.pisOrderDetail.forEach((item) => {
                  this.multipleSelection.push(item);
                  if (
                     JSON.parse(sessionStorage.getItem("setPin1")) != undefined
                  ) {
                     this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
                     this.params1.forEach((val, index) => {
                        this.mingList.forEach((item1) => {
                           if (item1.bgmId == val.bgmId) {
                              // this.selectedDetailsIndex1 = index;
                              this.formData.resource = String(val.controlType);
                              this.formData.quantity = val.quantity;
                              this.sendDataInfo.pisOrderDetail =
                                 val.controlRule;
                           }
                        });
                     });
                  } else {
                     // this.formData.resource = "0";
                     // this.formData.quantity = 0;
                     // this.sendDataInfo.pisOrderDetail = [];
                     // this.mainFormPin.pisOrderDetail.forEach((val, index) => {
                     //    this.controlGoodTempAdds.forEach((item) => {
                     //       if (
                     //          // item.bgmId == val.bgmId &&
                     //          item.controlGoodTempAdds.length > 0
                     //       ) {
                     //          this.mingListDan = val;
                     //          this.selectedDetailsIndex1 = index;
                     //          this.formData.resource = String(item.controlType);
                     //          this.formData.quantity = item.controlNum;
                     //          this.sendDataInfo.pisOrderDetail =
                     //             item.controlGoodTempAdds;
                     //       }
                     //       //  else {
                     //       //    this.mingListDan =
                     //       //       this.mainFormPin.pisOrderDetail[0];
                     //       // }
                     //    });
                     // this.$nextTick(() => {
                     //    this.multipleSelection.forEach((iten) => {
                     //       this.$refs.multipleTable.toggleRowSelection(iten);
                     //    });
                     // });
                     // });
                     // this.params1 = this.mainFormPin.pisOrderDetail;
                     // sessionStorage.setItem(
                     //    "setPin1",
                     //    JSON.stringify(this.params1)
                     // );
                  }
               });
               this.$nextTick(() => {
                  this.multipleSelection.forEach((iten) => {
                     this.$refs.multipleTable.toggleRowSelection(iten);
                     console.log(this.multipleSelection);
                  });
                  this.mainFormPin.pisOrderDetail.splice(1, 0);
               });
            } else {
               //开关关闭时 单选操作

               let setPin = JSON.parse(sessionStorage.getItem("setPin1"));
               console.log(setPin, "ddddd");
               //&& setPin[0].bgmId
               if (setPin && Array.isArray(setPin)) {
                  // 本地存储数据时
                  // this.params1 = this.mingList;
                  sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
                  this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
                  console.log(this.params1);
                  this.params1.forEach((val, index) => {
                     this.mingList.forEach((item1) => {
                        if (item1.bgmId == val.bgmId) {
                           console.log(val.quantity);
                           this.selectedDetailsIndex1 = index;
                           this.formData.resource = String(val.controlType);
                           this.formData.quantity = val.quantity;
                           this.sendDataInfo.pisOrderDetail = val.controlRule;
                        }
                        // else {
                        //    val.controlType = "0";
                        //    val.quantity = 0;
                        //    val.controlRule = [];
                        // }
                     });
                     console.log(this.mingList, " this.mingList");
                  });
                  this.params1 = this.mingList;
                  sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
                  this.$nextTick(() => {
                     this.multipleSelection.forEach((iten) => {
                        this.$refs.multipleTable.toggleRowSelection(iten);
                     });
                     this.mainFormPin.pisOrderDetail.splice(1, 0);
                  });
               } else {
                  //本地params不存在时

                  if (this.actionType == "0") {
                     this.mainFormPin.pisOrderDetail.forEach((val, index) => {
                        val.controlType = "0";
                        val.quantity = 0;
                        val.controlRule = [];
                        this.formData.resource = "0";
                        this.formData.quantity = 0;
                     });
                     this.params1 = this.mainFormPin.pisOrderDetail;
                     sessionStorage.setItem(
                        "setPin1",
                        JSON.stringify(this.params1)
                     );
                  } else {
                     this.mainFormPin.pisOrderDetail.forEach((val, index) => {
                        this.controlGoodTempAdds.forEach((item) => {
                           if (
                              item.bgmId == val.bgmId
                              // item.controlGoodTempAdds.length > 0
                           ) {
                              this.mingListDan = val;
                              this.selectedDetailsIndex1 = index;
                              val.controlType = String(item.controlType);
                              val.quantity = item.controlNum;
                              val.controlGoodTempAdds =
                                 item.controlGoodTempAdds;
                              val.controlRule = item.controlGoodTempAdds;
                              // this.mingListDan = val;
                              // this.selectedDetailsIndex1 = index;
                              // val.controlType = String(item.controlType);
                              // val.quantity = item.controlNum;
                              // val.controlGoodTempAdds = item.controlGoodTempAdds;
                              // val.controlRule = item.controlGoodTempAdds;
                           }
                        });
                        this.$nextTick(() => {
                           this.multipleSelection.forEach((iten) => {
                              this.$refs.multipleTable.toggleRowSelection(iten);
                              console.log(this.mainFormPin.pisOrderDetail);
                           });
                           this.mainFormPin.pisOrderDetail.splice(1, 0);
                        });
                     });
                     this.params1 = this.mainFormPin.pisOrderDetail;
                     sessionStorage.setItem(
                        "setPin1",
                        JSON.stringify(this.params1)
                     );
                  }
               }
            }
         },
         immediate: true,
      },
   },
   methods: {
      //删除当前选中明细
      delcurrent() {
         if (JSON.parse(sessionStorage.getItem("setPin1")) != undefined) {
            this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
            this.params1.filter((currAll, index1) => {
               if (currAll.bgmId == this.mingListDan.bgmId) {
                  console.log(currAll, "currAll");
                  console.log(this.mingListDan, "this.mingListDan");
                  this.selectedDetailsIndex1 = 0;
                  return this.mainFormPin.pisOrderDetail.splice(index1, 1);
               }
            });
            this.params1 = this.mainFormPin.pisOrderDetail;
            sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
            this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
            this.params1.forEach((val) => {
               // this.mingList.forEach((item1) => {
               // if (item1.bgmId == val.bgmId) {
               this.formData.resource = String(val.controlType);
               this.formData.quantity = val.quantity;
               this.sendDataInfo.pisOrderDetail = val.controlRule;
               // }
               // });
            });
            this.params1 = this.mainFormPin.pisOrderDetail;
            sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
            this.mainFormPin.pisOrderDetail.splice(1, 0);
         }
         this.mainFormPin.pisOrderDetail.splice(1, 0);
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         if (field == "keydown") {
            if (this.sendDataInfo.pisOrderDetail[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               return;
            }
            this.addDetail("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //明细规则单
      changeinput(row) {
         console.log(row);
         this.mingListDan = JSON.parse(JSON.stringify(row));
         // this.params1 = [];
         // this.formData.resource = "0";
         // this.formData.quantity = 0;
         // this.sendDataInfo.pisOrderDetail = [];
         if (JSON.parse(sessionStorage.getItem("setPin1")) != undefined) {
            this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
            this.params1.forEach((val) => {
               // this.mingList.forEach((item1) => {
               if (this.mingListDan.bgmId == val.bgmId) {
                  console.log(val, "val");
                  if (val.controlType == undefined) {
                     this.formData.resource = "0";
                     this.formData.quantity = 0;
                     this.sendDataInfo.pisOrderDetail = [];
                  } else {
                     this.formData.resource = String(val.controlType);
                     this.formData.quantity =  val.quantity;
                     this.sendDataInfo.pisOrderDetail = val.controlRule;
                  }
                  // this.sendDataInfo.pisOrderDetail.splice(1, 0);
               }
               // else {
               //    this.formData.resource = "0";
               //    this.formData.quantity = 0;
               //    this.sendDataInfo.pisOrderDetail = [];
               // }
               // });
            });
         }
         // else {
         //    this.controlGoodTempAdds.forEach((val) => {
         //       console.log(val);
         //       if (
         //          this.mingListDan.bgmId == val.bgmId &&
         //          val.controlGoodTempAdds.length > 0
         //       ) {
         //          this.formData.resource = String(val.controlType);
         //          this.formData.quantity = val.controlNum;
         //          this.sendDataInfo.pisOrderDetail = val.controlGoodTempAdds;
         //          this.sendDataInfo.pisOrderDetail.splice(1, 0);
         //       }
         //    });
         // }
      },
      //切换规则
      changeGZ() {
         this.formData.quantity = 0;
         this.sendDataInfo.pisOrderDetail = [];
      },
      //默认禁止
      selectHandle(row) {
         return false;
      },
      //开关选择
      changeSwitch() {
         console.log(this.allAndself);
         //新增切换状态携带数据
         if (this.actionType == "0") {
            if (
               sessionStorage.getItem("allAndself") != undefined &&
               JSON.parse(sessionStorage.getItem("allAndself")) == this.allAndself
            ) {
               this.multipleSelection = [];
               this.mainFormPin.pisOrderDetail.forEach((item) => {
                  // this.$nextTick(() => {
                  //    this.multipleSelection.push(item);
                  //    this.$refs.multipleTable.toggleRowSelection(
                  //       this.multipleSelection
                  //    );
                  // });
                  if (
                     JSON.parse(sessionStorage.getItem("setPin1")) != undefined
                  ) {
                     this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
                     this.params1.forEach((val) => {
                        if (this.mingList.bgmId == val.bgmId) {
                           this.formData.resource = String(val.controlType);
                           this.formData.quantity = val.controlNum;
                           this.sendDataInfo.pisOrderDetail = val.controlRule;
                           this.sendDataInfo.pisOrderDetail.splice(1, 0);
                           console.log(this.sendDataInfo.pisOrderDetail);
                        }
                     });
                  }
               });
            } else {
               this.formData.resource = "0";
               this.formData.quantity = 0;
               this.sendDataInfo.pisOrderDetail = [];
            }
         } else {
            this.multipleSelection = [];
            // if ( sessionStorage.getItem("allAndself") != undefined && JSON.parse(sessionStorage.getItem("allAndself")) == this.allAndself) {
            this.mainFormPin.pisOrderDetail.forEach((item) => {
               // this.$nextTick(() => {
               //    this.multipleSelection.push(item);
               //    this.$refs.multipleTable.toggleRowSelection(
               //       this.multipleSelection
               //    );
               // });
               //本地修改存储
               if (JSON.parse(sessionStorage.getItem("setPin1")) != undefined) {
                  this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
                  this.params1.forEach((val) => {
                     if (this.mingList.bgmId == val.bgmId) {
                        this.formData.resource = String(val.controlType);
                        this.formData.quantity = val.controlNum;
                        this.sendDataInfo.pisOrderDetail = val.controlRule;
                        this.sendDataInfo.pisOrderDetail.splice(1, 0);
                        console.log(this.sendDataInfo.pisOrderDetail);
                     }
                  });
               }
               // else {
               //    this.controlGoodTempAdds.forEach((item1, index) => {
               //       if (item1.controlType != null) {
               //          // this.selectedDetailsIndex1 = 0;
               //          this.$nextTick(() => {
               //             this.$refs.multipleTable.toggleRowSelection(
               //                this.multipleSelection[index + 1]
               //             );
               //          });
               //          // this.multipleSelection.push(item1) ;
               //          this.formData.resource = String(item1.controlType);
               //          this.formData.quantity = item1.controlNum;
               //          this.sendDataInfo.pisOrderDetail =
               //             item1.controlGoodTempAdds;
               //       }
               //    });
               // }
            });
            // }
         }
      },

      //保存数据
      preservation() {
         sessionStorage.removeItem("setPin1");
         sessionStorage.setItem("allAndself", this.allAndself);
         // if (this.sendDataInfo.pisOrderDetail.length <= 0) {
         //    this.$message.info("规则维护不可为空");
         //    return;
         // }
         this.mingList = this.mainFormPin.pisOrderDetail;

         //单选
         if (!this.allAndself) {
            // if (this.mingListDan.length == 1) {
            //    if (
            //       this.mingListDan.psodPacknum < Number(this.formData.quantity)
            //    ) {
            //       this.$message.info("控销数量不可超过明细数量");
            //       return;
            //    }
            // }
            if (this.formData.resource == "0") {
               this.setcpd = {
                  cmId: 0,
                  cpdtValue: "",
               };
            } else {
               this.setcpd = {
                  cmId: null,
                  cpdtValue: "",
               };
            }
            this.setPin1 = {
               // controlRule: [],
            };
            this.setPin = {
               // controlRule: [],
            };
            // this.params = [];
            // this.params1 = [];
            this.mingList.forEach((item1) => {
               if (this.formData.resource == "0") {
                  this.setcpd = {
                     cmId: 0,
                     cpdtValue: "",
                  };
               } else {
                  this.setcpd = {
                     cmId: null,
                     cpdtValue: "",
                  };
               }
               this.setPin1 = {
                  controlRule: [],
               };
               this.setPin = {
                  controlRule: [],
               };

               if (item1.bgmId == this.mingListDan.bgmId) {
                  console.log(item1, "item1");
                  this.setPin1.bgmId = item1.bgmId;
                  this.setPin1.controlType = this.formData.resource;
                  this.setPin1.controlNum = Number(this.formData.quantity);
                  this.setPin1.controlRule = this.sendDataInfo.pisOrderDetail;

                  if (this.allAndself) {
                     this.setPin1.controlModel = 1;
                  } else {
                     this.setPin1.controlModel = 0;
                  }
                  this.setPin.bgmId = item1.bgmId;
                  this.setPin.controlType = this.formData.resource;
                  this.setPin.controlNum = Number(this.formData.quantity);
                  if (this.allAndself) {
                     this.setPin.controlModel = 1;
                  } else {
                     this.setPin.controlModel = 0;
                  }
                  if (this.formData.resource == "0") {
                     this.sendDataInfo.pisOrderDetail.forEach((val, index) => {
                        this.setcpd.cmId = val.cmId;
                        this.setcpd.cpdtValue = val.cpdtValue;
                        this.setPin.controlRule.push(
                           JSON.parse(JSON.stringify(this.setcpd))
                        );
                     });
                  } else {
                     this.sendDataInfo.pisOrderDetail.forEach((val, index) => {
                        this.setcpd.cmId = null;
                        this.setcpd.cpdtValue = val.cpdtValue;
                        this.setPin.controlRule.push(
                           JSON.parse(JSON.stringify(this.setcpd))
                        );
                     });
                  }
               }
               // else {
               //    this.setPin1.bgmId = item1.bgmId;
               //    this.setPin1.controlType = "";
               //    this.setPin1.controlNum = 0;
               //    this.setPin1.controlRule = [];
               //    this.setPin.bgmId = item1.bgmId;
               //    this.setPin.controlType = "";
               //    this.setPin.controlNum = 0;
               //    this.setPin.controlRule = [];
               // }

               this.params.push(this.setPin);
               this.params1.push(this.setPin1);
            });
            const res = new Map();
            this.params1 = this.params1.filter(
               (arr) => !res.has(arr.bgmId) && res.set(arr.bgmId, arr.bgmId)
            );
            const res1 = new Map();
            this.params = this.params.filter(
               (arr) => !res1.has(arr.bgmId) && res1.set(arr.bgmId, arr.bgmId)
            );
            this.params.filter((filePars, index) => {
               if (filePars.bgmId == undefined) {
                  return this.params.splice(index, 1);
               }
            });
            this.params1.filter((filePars, index) => {
               if (filePars.bgmId == undefined) {
                  console.log(filePars);
                  return this.params1.splice(index, 1);
               }
            });
            console.log(this.params, " this.params");
            console.log(this.params1, " this.params1");

            // this.$emit("controlPin", this.params);
         }
         // if (sessionStorage.getItem("setPin1") != null) {
         //    let oldPrams = JSON.parse(sessionStorage.getItem("setPin1"));

         //    oldPrams.forEach((item) => {
         //       this.params.forEach((item1) => {
         //          if (item.bgmId != item1.bgmId) {
         //             console.log(item);
         //             this.params.push(item);
         //             this.params1.push(item);
         //          }
         //       });
         //    });
         // }
         // else {
         //    this.mainFormPin.controlGoodTempAdds.forEach((item) => {
         //       this.params.forEach((item1) => {
         //          if (item.bgmId != item1.bgmId) {
         //             this.params.push(item);
         //             this.params1.push(item);
         //          }
         //       });
         //    });
         // }
         const res = new Map();
         this.params1 = this.params1.filter(
            (arr) => !res.has(arr.bgmId) && res.set(arr.bgmId, arr.bgmId)
         );
         const res1 = new Map();
         this.params = this.params.filter(
            (arr) => !res1.has(arr.bgmId) && res1.set(arr.bgmId, arr.bgmId)
         );
         sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
         //全选
         // else {
         // this.multipleSelection = this.mainFormPin.pisOrderDetail;
         // this.multipleSelection.forEach((item, index) => {
         //    if (item.psodPacknum <= this.minpsodPacknum) {
         //       this.minpsodPacknum = item.psodPacknum;
         //    }
         // });
         // this.params = [];
         // this.params1 = [];
         // this.multipleSelection.forEach((item1) => {
         //    if (this.formData.resource == "0") {
         //       this.setcpd = {
         //          cmId: 0,
         //          cpdtValue: "",
         //       };
         //    } else {
         //       this.setcpd = {
         //          cmId: null,
         //          cpdtValue: "",
         //       };
         //    }
         //    this.setPin1 = {
         //       controlRule: [],
         //    };
         //    this.setPin = {
         //       controlRule: [],
         //    };
         //    this.setPin1.bgmId = item1.bgmId;
         //    this.setPin1.controlType = this.formData.resource;
         //    this.setPin1.controlNum = Number(item1.psodPacknum);
         //    this.setPin1.controlRule = this.sendDataInfo.pisOrderDetail;
         //    if (this.allAndself) {
         //       this.setPin1.controlModel = 1;
         //    } else {
         //       this.setPin1.controlModel = 0;
         //    }
         //    this.setPin.bgmId = item1.bgmId;
         //    this.setPin.controlType = this.formData.resource;
         //    this.setPin.controlNum = Number(item1.psodPacknum);
         //    if (this.allAndself) {
         //       this.setPin.controlModel = 1;
         //    } else {
         //       this.setPin.controlModel = 0;
         //    }
         //    if (this.formData.resource == "0") {
         //       this.sendDataInfo.pisOrderDetail.forEach((val, index) => {
         //          this.setcpd.cmId = val.cmId;
         //          this.setcpd.cpdtValue = val.cpdtValue;
         //          this.setPin.controlRule.push(
         //             JSON.parse(JSON.stringify(this.setcpd))
         //          );
         //       });
         //    } else {
         //       this.sendDataInfo.pisOrderDetail.forEach((val, index) => {
         //          this.setcpd.cmId = null;
         //          this.setcpd.cpdtValue = val.cpdtValue;
         //          this.setPin.controlRule.push(
         //             JSON.parse(JSON.stringify(this.setcpd))
         //          );
         //       });
         //    }
         //    this.params.push(this.setPin);
         //    this.params1.push(this.setPin1);
         // });
         // const res = new Map();
         // this.params1 = this.params1.filter(
         //    (arr) => !res.has(arr.bgmId) && res.set(arr.bgmId, arr.bgmId)
         // );
         // const res1 = new Map();
         // this.params = this.params.filter(
         //    (arr) => !res1.has(arr.bgmId) && res1.set(arr.bgmId, arr.bgmId)
         // );
         // console.log(this.params, " this.params");
         // console.log(this.params1, " this.params1");
         // sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
         // this.$emit("controlPin", this.params);
         // }
      },
      //保存并跳转
      setDetail() {
         sessionStorage.setItem("allAndself", this.allAndself);
         if (this.allAndself) {
            if (this.sendDataInfo.pisOrderDetail.length <= 0) {
               this.$message.info(item.bgmName + "规则维护不可为空");
               return;
            }
            this.multipleSelection = this.mainFormPin.pisOrderDetail;
            this.multipleSelection.forEach((item, index) => {
               if (item.psodPacknum <= this.minpsodPacknum) {
                  this.minpsodPacknum = item.psodPacknum;
               }
            });
            this.params = [];
            this.params1 = [];

            this.multipleSelection.forEach((item1) => {
               if (this.formData.resource == "0") {
                  this.setcpd = {
                     cmId: 0,
                     cpdtValue: "",
                  };
               } else {
                  this.setcpd = {
                     cmId: null,
                     cpdtValue: "",
                  };
               }
               this.setPin1 = {
                  controlRule: [],
               };
               this.setPin = {
                  controlRule: [],
               };
               // this.setPin1.bgmId = item1.bgmId;
               // this.setPin1.controlType = this.formData.resource;
               // this.setPin1.controlNum = Number(item1.psodPacknum);
               // this.setPin1.controlRule = this.sendDataInfo.pisOrderDetail;
               item1.controlType = this.formData.resource;
               item1.quantity = Number(item1.psodPacknum);
               item1.controlRule = this.sendDataInfo.pisOrderDetail;
               if (this.allAndself) {
                  item1.controlRule.controlModel = 1;
               } else {
                  item1.controlRule.controlModel = 0;
               }

               this.setPin.bgmId = item1.bgmId;
               this.setPin.controlType = this.formData.resource;
               this.setPin.controlNum = Number(item1.psodPacknum);
               if (this.allAndself) {
                  this.setPin.controlModel = 1;
               } else {
                  this.setPin.controlModel = 0;
               }
               if (this.formData.resource == "0") {
                  this.sendDataInfo.pisOrderDetail.forEach((val, index) => {
                     this.setcpd.cmId = val.cmId;
                     this.setcpd.cpdtValue = val.cpdtValue;
                     this.setPin.controlRule.push(
                        JSON.parse(JSON.stringify(this.setcpd))
                     );
                  });
               } else {
                  this.sendDataInfo.pisOrderDetail.forEach((val, index) => {
                     this.setcpd.cmId = null;
                     this.setcpd.cpdtValue = val.cpdtValue;
                     this.setPin.controlRule.push(
                        JSON.parse(JSON.stringify(this.setcpd))
                     );
                  });
               }

               this.params.push(this.setPin);
               // this.params1.push(this.setPin1);
               this.params1 = this.mainFormPin.pisOrderDetail;
            });

            const res = new Map();
            this.params1 = this.params1.filter(
               (arr) => !res.has(arr.bgmId) && res.set(arr.bgmId, arr.bgmId)
            );
            const res1 = new Map();
            this.params = this.params.filter(
               (arr) => !res1.has(arr.bgmId) && res1.set(arr.bgmId, arr.bgmId)
            );
            console.log(this.params, " this.params");
            console.log(this.params1, " this.params1");
            sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
         } else {
            this.params1 = JSON.parse(sessionStorage.getItem("setPin1"));
            this.tabshow=0
            this.params1.forEach((item) => {
               if (!item.controlRule || item.controlRule.length == 0) {
                  this.$message.info(item.bgmName + "规则维护不可为空");
                  this.tabshow= 1
                  return;
               }else if (Number(item.quantity) > item.psodPacknum) {
                  this.$message.info(item.bgmName + "控销数量超出");
                  this.tabshow=2
                  return;
               }
            });
            if(this.tabshow !=0){
               return
            }
            this.setPin = {};
            this.params1.forEach((item) => {
               console.log(item);
               this.setPin.bgmId = item.bgmId;
               this.setPin.controlType = item.controlType;
               this.setPin.controlNum = Number(item.quantity);
               if (this.allAndself) {
                  this.setPin.controlModel = 1;
               } else {
                  this.setPin.controlModel = 0;
               }
               this.setPin.controlRule = JSON.parse(
                  JSON.stringify(item.controlRule)
               );
               this.params.push(JSON.parse(JSON.stringify(this.setPin)));
            });
         }
         // sessionStorage.setItem("setPin1", JSON.stringify(this.params1));
         this.$emit("controlPin", this.params);
      },
      //打开弹框调取数据
      openBox() {
         this.mingList = this.mainFormPin.pisOrderDetail;
         if (sessionStorage.getItem("allAndself") != undefined) {
            if (sessionStorage.getItem("allAndself") == "true") {
               this.allAndself = true;
            } else if (sessionStorage.getItem("allAndself") == "false") {
               this.allAndself = false;
            } else {
               this.allAndself = true;
            }
         }
         this.controlGoodTempAdds = [];
         //新增
         if (this.actionType == "0") {
            this.formData.resource = "0";
            this.formData.quantity = 0;
            this.sendDataInfo.pisOrderDetail = [];
            this.mingListDan = this.mainFormPin.pisOrderDetail[0];
            if (sessionStorage.getItem("setPin1") != null) {
               this.controlGoodTempAdds = JSON.parse(
                  sessionStorage.getItem("setPin1")
               );
               //拿取本地数据
               this.isshow = 0;
            } else {
               this.isshow = 1;
               this.controlGoodTempAdds = [];
            }
            //修改
         } else if (this.actionType == "1") {
            if (this.mainFormPin.controlGoodTempAdds[0].controlModel == 0) {
               this.allAndself = false;
            } else if (
               this.mainFormPin.controlGoodTempAdds[0].controlModel == 1
            ) {
               this.allAndself = true;
            } else {
               this.allAndself = true;
            }
            //拿取本地数据
            if (sessionStorage.getItem("setPin1") != null) {
               this.controlGoodTempAdds = JSON.parse(
                  sessionStorage.getItem("setPin1")
               );
               this.isshow = 0;
            } else {
               //拿取修改携带数据
               this.isshow = 1;
               this.controlGoodTempAdds = this.mainFormPin.controlGoodTempAdds;
            }
         }
         //新增初始进入
         if (this.controlGoodTempAdds.length == 0) {
            // this.formData.resource = "0";
            // this.formData.quantity = 0;
            // this.sendDataInfo.pisOrderDetail = [];
            // this.mainFormPin.pisOrderDetail.forEach((val) => {
            //    this.multipleSelection.push(val);
            // });
            // const res = new Map();
            // this.multipleSelection = this.multipleSelection.filter(
            //    (arr) => !res.has(arr.bgmId) && res.set(arr.bgmId, arr.bgmId)
            // );
            // this.$refs.multipleTable.toggleRowSelection(
            //    this.multipleSelection
            // );
         } else {
            if (this.isshow == 0) {
               // this.mainFormPin.pisOrderDetail.forEach((val) => {
               //    this.controlGoodTempAdds.forEach((item, index) => {
               //       if (
               //          item.bgmId == val.bgmId &&
               //          item.controlRule.length > 0
               //       ) {
               //          this.mingListDan = val;
               //          // this.selectedDetailsIndex1 = index;
               //          this.formData.resource = String(item.controlType);
               //          this.formData.quantity = item.controlNum;
               //          this.sendDataInfo.pisOrderDetail = item.controlRule;
               //          // console.log(this.multipleSelection);
               //          return;
               //       }
               //    });
               // });
               this.mainFormPin.pisOrderDetail.forEach((val) => {
                  this.controlGoodTempAdds.forEach((item1, index) => {
                     if (item1.controlType != null) {
                        // this.selectedDetailsIndex1 = index;
                        this.formData.resource = String(item1.controlType);
                        this.formData.quantity = item1.quantity;
                        this.sendDataInfo.pisOrderDetail = item1.controlRule;
                     } else {
                        this.mingListDan = val;
                     }
                  });
               });
            } else {
               console.log(this.controlGoodTempAdds, "00");
               this.mainFormPin.pisOrderDetail.forEach((val) => {
                  this.controlGoodTempAdds.forEach((item1, index) => {
                     if (item1.controlType != null) {
                        // this.selectedDetailsIndex1 = index;
                        this.formData.resource = String(item1.controlType);
                        this.formData.quantity = item1.controlNum;
                        this.sendDataInfo.pisOrderDetail =
                           item1.controlGoodTempAdds;
                        // this.sendDataInfo.pisOrderDetail =
                        //    item1.controlRule;
                     } else {
                        this.mingListDan = val;
                     }
                  });
               });
            }
         }
         console.log(this.sendDataInfo.pisOrderDetail);
         console.log(this.allAndself, " console.log(this.allAndself);");
         this.params = [];
         this.mainFormPin.pisOrderDetail.splice(1, 0);
         // this.sendDataInfo.pisOrderDetail.splice(1, 0);
      },
      //多选数据
      handleSelectionChange(val) {
         // this.multipleSelection = val;
         // console.log(" this.multipleSelection", this.multipleSelection);
         // if (this.multipleSelection.length == 0) {
         //    this.formData.resource = "0";
         //    this.formData.quantity = 0;
         //    this.sendDataInfo.pisOrderDetail = [];
         // }
         // this.multipleSelection.forEach((item) => {
         //    this.params1.forEach((val) => {
         //       if (item.bgmId == val.bgmId) {
         //          this.formData.resource = String(val.controlType);
         //          this.formData.quantity = val.controlNum;
         //          this.sendDataInfo.pisOrderDetail = val.controlRule;
         //       }
         //       // if(item.bgmId !=val.bgmId){
         //       //    this.formData.resource = "0";
         //       //    this.formData.quantity = 0;
         //       //    this.sendDataInfo.pisOrderDetail = [];
         //       // }
         //    });
         // });
      },
      //新增规则
      addDetail() {
         if (this.formData.resource == "") {
            this.$message.info("请选择规则！");
            return;
         }
         this.sendDataInfo.pisOrderDetail.push({
            cmId: "",
            cpdtValue: "",
         });
         this.$nextTick(() => {
            console.log(
               this.sendDataInfo.pisOrderDetail,
               " this.sendDataInfo.pisOrderDetail"
            );
            this.selectedDetailsIndex = Number(
               this.sendDataInfo.pisOrderDetail.length - 1
            );
            // let refsElTable = this.$refs.mxTableRef[0];
            // refsElTable.clearSelection();
            // refsElTable.toggleRowSelection(
            //    this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
            // );
         });
      },

      //删除规则
      deleteDetails() {
         if (this.sendDataInfo.pisOrderDetail.length < 1) {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }

         this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
         if (this.sendDataInfo.pisOrderDetail.length > 1) {
            this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
         } else {
            this.selectedDetailsIndex = 0;
         }
      },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, nosField) {
         if (this.formData.resource == "0") {
            this.seId = "3391151360249856";
            this.seType = "dw";
         } else if (this.formData.resource == "1") {
            this.seId = "8820873997127687";
            this.parentSearchData.dtId = "38";
            this.seType = "dq";
         } else if (this.formData.resource == "2") {
            this.seId = "8820873997127687";
            this.parentSearchData.dtId = "48";
            this.seType = "dq";
         }
         console.log(sId);
         this.DialogVisible = true;
         removeEventListener("keyup", this.keyUp);

         this.seIndex = index;
         // this.seType = type;
         this.sField = sField;
         this.fField = fField;
         //  if (type == "bgmName") {
         //     this.parentSearchData.stId = this.sendDataInfo.stId;
         //     this.parentSearchData.cmId = this.sendDataInfo.cmId;
         //     this.parentSearchData.coId = this.sendDataInfo.coId;

         //     this.parentSearchData.bgmName =
         //        this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName;
         //     return;
         //  }
         this.parentSearchData[type] = this.sendDataInfo[type];
      },
      //提取返回
      changeInputModel(val) {
         console.log("返回", val);
         if (val != "" && val != undefined) {
            this.DialogVisible = false;
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
            if (val.depId) {
               this.sendDataInfo.depId = val.depId;
               this.sendDataInfo.depName = val.depName;
            }
            if (this.seType == "bgmName") {
               let bgiTypeArr = [];
               var repeatBgmId=[]
               this.sendDataInfo.pisOrderDetail.forEach((v) => {
                   if (v.bgmName != '' && v.bgmId != "") {
                     bgiTypeArr.push(v.bgiType);
                     repeatBgmId.push(v.bgmId);
                  }
               });
               bgiTypeArr.push(val.bgiType)
               repeatBgmId.push(val.bgmId);
               this.$http
                  .checkPurchasingScope({
                     //校验明细商品
                     formId: this.mxForm.jciId, //表单ID
                     unitId: this.sendDataInfo.smId, //单位ID
                     bgmId: [val.bgmId], //商品id
                     ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, //组织ID
                     salesId: this.sendDataInfo.salesId, //对方业务员ID
                     bgiTypes: bgiTypeArr, //药品类型
                  })
                  .then((res) => {
                     if (res && res.status == 200) {
                        for (let key in val) {
                           this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                              val[key];
                        }
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPsdvolume = val.rjXl;
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPsnvolume = val.stockNum;
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPsupperlimit = val.limdHighnum;
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPslowerlimit = val.limdLownum;
                        this.tableNextFocus(this.fField, this.seIndex);
                     } else if (res && res.status == 300) {
                        this.lineMessageBox(res);
                        for (let key in val) {
                           this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                              val[key];
                        }
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPsdvolume = val.rjXl;
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPsnvolume = val.stockNum;
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPsupperlimit = val.limdHighnum;
                        this.sendDataInfo.pisOrderDetail[
                           this.seIndex
                        ].psodPslowerlimit = val.limdLownum;
                     } else {
                        this.lineMessageBox(res);
                        this.$set(
                           this.sendDataInfo.pisOrderDetail,
                           this.seIndex,
                           JSON.parse(JSON.stringify(this.detaislDataInfo))
                        );
                        return false;
                     }
                  })
                  .catch((rej) => {
                     this.lineMessageBox(rej);
                     for (let key in this.sendDataInfo.pisOrderDetail[
                        this.seIndex
                     ]) {
                        this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                           "";
                     }
                  });
            } else if (this.seType == "smName") {
               this.$http
                  .checkVendorLicense({
                     //校验购进单位
                     formId: this.formDataList[0].jciId, //表单ID
                     unitId: val.smId, //单位ID
                  })
                  .then((res) => {
                     if (res && res.status == 200) {
                        // if (this.sendDataInfo.smName != val.smName) {
                        //     this.sendDataInfo.salesName = "";
                        //     this.sendDataInfo.salesId = "";
                        // }
                        this.parentSearchData.smId = val.smId;
                        this.paramValue(val);
                     } else if (res && res.status == 300) {
                        this.lineMessageBox(res);

                        // if (this.sendDataInfo.smName != val.smName) {
                        //     this.clearValue();
                        // }
                        this.parentSearchData.smId = val.smId;
                        this.paramValue(val);
                        // this.clearValue();
                     } else {
                        this.lineMessageBox(res);

                        this.parentSearchData.smId = "";
                        this.clearValue();
                        return false;
                     }
                  })
                  .catch((rej) => {
                     this.lineMessageBox(rej);

                     this.parentSearchData.smId = "";
                     this.clearValue();
                  });
            } else if (this.seType == "salesName") {
               this.$http
                  .checkSalesLicense({
                     //校验供应商业务员
                     formId: this.formDataList[0].jciId, //表单ID
                     salesId: val.salesId, //业务员ID
                  })
                  .then((res) => {
                     if (res && res.status == 200) {
                        this.paramValue(val);
                     } else if (res && res.status == 300) {
                        this.lineMessageBox(res);

                        this.paramValue(val);
                     } else {
                        this.lineMessageBox(res);

                        this.clearValue();
                        return false;
                     }
                  })
                  .catch((rej) => {
                     this.lineMessageBox(rej);

                     this.clearValue();
                  });
            } else if (this.seType == "stName") {
               this.mxParamValue(val);
            } else if (this.seType == "dw") {
               this.sendDataInfo.pisOrderDetail[this.seIndex].cmId = val.cmId;
               this.sendDataInfo.pisOrderDetail[this.seIndex].cpdtValue =
                  val.cmName;
               this.sendDataInfo.pisOrderDetail.splice(1, 0);
            } else if (this.seType == "dq") {
               this.sendDataInfo.pisOrderDetail[this.seIndex].cmId = val.diId;
               this.sendDataInfo.pisOrderDetail[this.seIndex].cpdtValue =
                  val.diName;
               this.sendDataInfo.pisOrderDetail.splice(1, 0);
            } else {
               this.paramValue(val);
            }
         }
         // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
         this.changeFocus();
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
         //  this.$nextTick(() => {
         //     this.nextFocus(this.seIndex);
         //  });
      },
      // 表格赋值字段
      mxParamValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo.pisOrderDetail[this.seIndex][item] = val[item];
         });
         this.$nextTick(() => {
            this.tableNextFocus(this.fField, this.seIndex);
         });
      },
      // 清除赋值字段数据
      clearValue() {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = "";
         });
      },
      changeFocus() {
         setTimeout(() => {
            var el = document.getElementById("mainInfo");
            var inel = el.getElementsByClassName("el-input__inner");
            for (let index = 0; index < inel.length; index++) {
               if (inel[index].value == "") {
                  console.log(inel[index]);
                  inel[index].focus();
                  break;
               }
            }
         }, 500);
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      closeChild() {
         addEventListener("keyup", this.keyUp); //创建监听键盘事件
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
         this.isLoaded = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {},
   beforeCreate() {}, //生命周期 - 创建之前
   beforeMount() {}, //生命周期 - 挂载之前
   beforeUpdate() {}, //生命周期 - 更新之前
   updated() {}, //生命周期 - 更新之后
   beforeDestroy() {}, //生命周期 - 销毁之前
   destroyed() {}, //生命周期 - 销毁完成
   activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.pin-top {
   width: 100%;
   display: flex;
   justify-content: space-between;
}
.conpin-left {
   width: 50%;
}
.conpin-right {
   width: 50%;
}
.text {
   font-size: 14px;
}

.item {
   margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
   display: table;
   content: "";
}
.clearfix:after {
   clear: both;
}

.box-card {
   /* width: 480px; */
   height: 500px;
}
</style>